import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Users } from 'lucide-react';

const TeamManagement = ({ platform }) => (
  <Card>
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <Users className="w-5 h-5" />
        Team Management — {platform}
      </CardTitle>
    </CardHeader>
    <CardContent>
      <p className="text-gray-500 text-sm">Team management features coming soon.</p>
    </CardContent>
  </Card>
);

export default TeamManagement;
